import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["icon"],
    _excluded2 = ["dataTestId", "hideIcon", "hideLabel", "icon", "isOpen", "label", "size"];

var _menuSwitcherButtonSi, _menuSwitcherVertical, _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { NormalizedButton } from "../../button";
import { IconArrowDropDown } from "../../icons";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ElementStateWrapper, getRem, typographyButton, visuallyHidden } from "../../core";
import { MENU_SWITCHER_SIZES } from "../constants";
import { menuSwitcherButtonStateStyles } from "../menuSwitcherStateStyles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var menuSwitcherButtonSizes = (_menuSwitcherButtonSi = {}, _defineProperty(_menuSwitcherButtonSi, MENU_SWITCHER_SIZES.LARGE, getRem('40px')), _defineProperty(_menuSwitcherButtonSi, MENU_SWITCHER_SIZES.SMALL, getRem('32px')), _defineProperty(_menuSwitcherButtonSi, MENU_SWITCHER_SIZES.STANDARD, getRem('36px')), _menuSwitcherButtonSi);
var menuSwitcherVerticalPadding = (_menuSwitcherVertical = {}, _defineProperty(_menuSwitcherVertical, MENU_SWITCHER_SIZES.LARGE, getRem('8px')), _defineProperty(_menuSwitcherVertical, MENU_SWITCHER_SIZES.SMALL, getRem('4px')), _defineProperty(_menuSwitcherVertical, MENU_SWITCHER_SIZES.STANDARD, getRem('6px')), _menuSwitcherVertical);
var StyledMenuSwitcherButton = styled(NormalizedButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var isOpen = _ref.isOpen,
      size = _ref.size,
      theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", ";\n    cursor: pointer;\n    display: flex;\n    height: ", ";\n    padding: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n\n    &::after {\n      &:hover {\n        background-color: ", ";\n        cursor: pointer;\n      }\n    }\n  "])), isOpen ? theme.color.gray[200].value : theme.color.additional.light.value, theme.size.borderRadius.medium.value, menuSwitcherButtonSizes[size], menuSwitcherVerticalPadding[size], theme.size.spacing.medium.value, theme.size.spacing.small.value, theme.color.gray[200].value);
});
var StyledIcon = styled(function (_ref2) {
  var icon = _ref2.icon,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.cloneElement(icon, props);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fill: ", ";\n  height: ", ";\n  width: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.text.light.secondary.value;
}, getRem(24), getRem(24));
var StyledLabel = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var hideLabel = _ref4.hideLabel,
      size = _ref4.size,
      theme = _ref4.theme;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n    ", ";\n    ", ";\n    color: ", ";\n    padding: ", ";\n  "])), hideLabel && visuallyHidden, typographyButton(theme), size === MENU_SWITCHER_SIZES.LARGE && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      font-size: ", ";\n      line-height: 1;\n    "])), getRem('16px')), theme.color.text.light.secondary.value, hideLabel ? 0 : "".concat(getRem(2), " 0 ").concat(getRem(2), " ").concat(theme.size.spacing.small.value));
});
var StyledIconCaret = styled(IconArrowDropDown).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isOpen'].includes(prop);
  }
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  fill: ", ";\n  ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.text.light.secondary.value;
}, function (_ref6) {
  var isOpen = _ref6.isOpen;
  return isOpen && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      transform: rotate(180deg);\n    "])));
});
export var MenuSwitcherButton = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var dataTestId = _ref7.dataTestId,
      hideIcon = _ref7.hideIcon,
      hideLabel = _ref7.hideLabel,
      icon = _ref7.icon,
      isOpen = _ref7.isOpen,
      label = _ref7.label,
      size = _ref7.size,
      other = _objectWithoutProperties(_ref7, _excluded2);

  return /*#__PURE__*/_jsx(ElementStateWrapper, {
    stateStyles: menuSwitcherButtonStateStyles,
    children: /*#__PURE__*/_jsxs(StyledMenuSwitcherButton, _objectSpread(_objectSpread({
      "data-testid": dataTestId,
      isOpen: isOpen,
      ref: ref,
      size: size
    }, other), {}, {
      children: [!!icon && !hideIcon && /*#__PURE__*/_jsx(StyledIcon, {
        icon: icon
      }), /*#__PURE__*/_jsx(StyledLabel, {
        hideLabel: hideLabel,
        size: size,
        children: label
      }), /*#__PURE__*/_jsx(StyledIconCaret, {
        isOpen: isOpen
      })]
    }))
  });
});
MenuSwitcherButton.propTypes = {
  /** Id value used for testing */
  dataTestId: PropTypes.string,

  /** If true, hides icon from view switcher */
  hideIcon: PropTypes.bool,

  /** If true, visually hides label from view switcher */
  hideLabel: PropTypes.bool,

  /** Current icon of view switcher button */
  icon: PropTypes.node,

  /** If true, shows view switcher content */
  isOpen: PropTypes.bool,

  /** Label of pre-selected option */
  label: PropTypes.node,

  /** Changes view switcher container height */
  size: PropTypes.oneOf(Object.values(MENU_SWITCHER_SIZES))
};
MenuSwitcherButton.defaultProps = {
  dataTestId: undefined,
  hideIcon: false,
  hideLabel: false,
  icon: undefined,
  isOpen: false,
  label: undefined,
  size: MENU_SWITCHER_SIZES.STANDARD
};